<template>
  <svg
    fill="none"
    height="40"
    viewBox="0 0 40 40"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#FF3B30"
      height="40"
      rx="20"
      width="40"
    />
    <path
      d="M18.5996 25.808C18.7163 25.8997 18.8329 25.983 18.9579 26.0747C19.9079 26.7664 20.8663 27.3164 21.8246 27.7247C22.7829 28.133 23.6913 28.333 24.5413 28.333C25.1246 28.333 25.6663 28.2247 26.1663 28.0164C26.6746 27.808 27.1246 27.483 27.5329 27.033C27.7746 26.7664 27.9579 26.483 28.0996 26.183C28.2413 25.883 28.3079 25.5747 28.3079 25.2747C28.3079 25.0414 28.2579 24.833 28.1746 24.6247C28.0829 24.4164 27.9329 24.2414 27.7163 24.0914L24.9579 22.133C24.7496 21.9914 24.5579 21.883 24.3746 21.808C24.1913 21.733 24.0246 21.6997 23.8663 21.6997C23.6579 21.6997 23.4663 21.758 23.2746 21.8747C23.0829 21.9747 22.8829 22.133 22.6746 22.3414L22.0413 22.9664C21.9496 23.058 21.8413 23.108 21.6996 23.108C21.6246 23.108 21.5579 23.0997 21.4913 23.0747C21.4329 23.0497 21.3829 23.0247 21.3413 23.008C21.1829 22.9247 20.9996 22.808 20.7996 22.658"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <path
      d="M18.941 21.0165C18.5077 20.5748 18.1077 20.1332 17.7327 19.6998C17.366 19.2665 17.1077 18.9082 16.9577 18.6332C16.941 18.5832 16.916 18.5332 16.891 18.4665C16.8743 18.3998 16.866 18.3415 16.866 18.2748C16.866 18.1415 16.9077 18.0332 16.9993 17.9415L17.6327 17.2832C17.8327 17.0832 17.991 16.8832 18.0993 16.6915C18.216 16.4998 18.2743 16.2998 18.2743 16.0998C18.2743 15.9415 18.2327 15.7665 18.1577 15.5915C18.0827 15.4082 17.9743 15.2165 17.8243 15.0082L15.891 12.2832C15.741 12.0665 15.5493 11.9165 15.3327 11.8165C15.1243 11.7165 14.891 11.6665 14.6577 11.6665C14.041 11.6665 13.4577 11.9248 12.9243 12.4498C12.4827 12.8665 12.166 13.3332 11.966 13.8415C11.766 14.3415 11.666 14.8832 11.666 15.4498C11.666 16.3165 11.866 17.2248 12.266 18.1748C12.666 19.1165 13.216 20.0665 13.8993 21.0165C14.591 21.9665 15.366 22.8748 16.2243 23.7415"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <path
      d="M28.3327 11.6665L11.666 28.3332"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
